import { __rest as e } from "tslib";
import * as t from "react";
import a from "classnames";
import { classNameModifier as r } from "../shared/utils.js";
import { ComponentClassNames as i } from "../shared/constants.js";
import { View as l } from "../View/View.js";
var s = "linear-empty",
  n = "linear-filled",
  o = "circular-empty",
  c = "circular-filled",
  d = 8,
  m = 42,
  y = 84 * Math.PI,
  p = t.forwardRef(function (s, n) {
    var o = s.className,
      c = s.filledColor,
      d = s.emptyColor,
      m = s.size,
      p = s.variation,
      _s$isDeterminate = s.isDeterminate,
      f = _s$isDeterminate === void 0 ? !1 : _s$isDeterminate,
      _s$isPercentageTextHi = s.isPercentageTextHidden,
      x = _s$isPercentageTextHi === void 0 ? !1 : _s$isPercentageTextHi,
      _s$percentage = s.percentage,
      g = _s$percentage === void 0 ? 0 : _s$percentage,
      u = e(s, ["className", "filledColor", "emptyColor", "size", "variation", "isDeterminate", "isPercentageTextHidden", "percentage"]);
    g = Math.min(g, 100);
    var v = "".concat(g = Math.max(g, 0), "%"),
      h = a(i.Loader, r(i.Loader, m), r(i.Loader, p), f ? i.LoaderDeterminate : null, o),
      E = t.createElement("g", null, t.createElement("line", {
        x1: "0",
        x2: "100%",
        y1: "50%",
        y2: "50%",
        style: {
          stroke: String(d)
        },
        "data-testid": "linear-empty"
      }), t.createElement("line", {
        x1: "0",
        x2: f ? v : "100%",
        y1: "50%",
        y2: "50%",
        style: {
          stroke: f && 0 === g ? "none" : c ? String(c) : void 0
        },
        "data-testid": "linear-filled"
      }), f ? t.createElement("text", {
        "aria-live": "polite",
        className: a(i.LoaderPercentageText, x ? i.VisuallyHidden : null),
        x: "".concat(-1 + g, "%"),
        y: "200%"
      }, v) : null),
      k = t.createElement("g", null, t.createElement("circle", {
        cx: "50%",
        cy: "50%",
        r: "42%",
        strokeWidth: "8%",
        style: {
          stroke: String(d)
        },
        "data-testid": "circular-empty"
      }), t.createElement("circle", {
        cx: "50%",
        cy: "50%",
        r: "42%",
        strokeWidth: "8%",
        style: {
          stroke: String(c),
          strokeDasharray: f ? "".concat(y, "% ").concat(y, "%") : void 0,
          strokeDashoffset: f ? y - y * g / 100 + "%" : void 0
        },
        "data-testid": "circular-filled"
      }), f ? t.createElement("text", {
        "aria-live": "polite",
        className: a(i.LoaderPercentageText, x ? i.VisuallyHidden : null),
        x: "130%",
        y: "80%"
      }, v) : null);
    return t.createElement(l, Object.assign({
      as: "svg",
      className: h,
      "data-size": m,
      "data-variation": p,
      ref: n,
      role: "img"
    }, u), "linear" === p ? E : k);
  });
p.displayName = "Loader";
export { o as CIRCULAR_EMPTY, c as CIRCULAR_FILLED, d as CIRCULAR_STROKE_WIDTH, y as CIRCUMFERENCE, s as LINEAR_EMPTY, n as LINEAR_FILLED, p as Loader, m as RADIUS };